import React, { FC } from "react"
import { Props } from "./types"
import Placeholder from "./Placeholder"

const BlogThumbnail: FC<Props> = ({ url }) => {
  const colors = ["#c37ae3", "#00cdad", "#fe7676"]
  const randomColor = colors[Math.floor(Math.random() * colors.length)]
  return url ? <img src={url} /> : <Placeholder fill={randomColor} />
}

export default BlogThumbnail
